<template>
  <back-office-list
    :title="this.$t('common.integrations')"
    :has-add-button="true"
    :add-button-caption="this.$t('integrations.add')"
    :loading="integrationsMeta.loading"
    :list-data="integrations"
    route-to-add-page="add-integration"
    :selection-change="handleSelectionChange"
    :columns="columns"
  />
</template>

<script>
  import BackOfficeList from '@/components/BackOfficeList'
  import { useIntegrations } from './integrationHooks'
  import { AButton } from 'codefabrik-gui-vue'

  export default {
    name: 'Integrations',
    components: { BackOfficeList },
    mixins: [
      useIntegrations('integrations')
    ],
    methods: {
      handleSelectionChange (integration) {
        this.$router.push({ name: 'edit-integration', params: { id: integration.id } })
      },
      handlePush (integration, event) {
        event.stopPropagation()
        this.$router.push({ name: 'push-integration', params: { id: integration.id } })
      }
    },
    computed: {
      columns () {
        return [
          {
            header: this.$t('common.name'),
            field: 'name',
          },
          {
            size: "1",
            contentPosition: 'right',
            component: AButton,
            componentProperties: {
              text: "",
              iconLeft: 'fas fa-upload',
              variant: 'primary'
            },
            componentListeners: {
              click: this.handlePush
            }
          }
        ]
      },
    },
  }
</script>

<style
  lang="scss"
  scoped
>
</style>
